import { ExtraServiceWithTimeSlice } from '@numa-group/checkout-api';
import { UserInfo } from '@numa-group/checkout-api/dist/schemas/user-info.schema';
import { AxiosInstance } from 'axios';

import { IAuthService } from '@src/features/auth/services/i-auth-service';
import { getUserIdAndFingerPrintHeader } from '@src/services/misc/headers';
import { GetOffersResponse } from '@src/types/api/models/offers';
import { GetOffersRequest } from '@src/types/api/requests/get-offers-request';
import { GetServiceOffersQuery } from '@src/types/api/requests/get-service-offers-request';
import { ApiResponse } from '@src/types/api/response/api-response';

import { OfferRepository } from './offer.repository';

export class OfferRepositoryAxios implements OfferRepository {
  constructor(
    private readonly axiosInstance: AxiosInstance,
    private readonly authService: IAuthService,
  ) {}

  async getOffers(params: GetOffersRequest, config?: { user: Partial<UserInfo> }): Promise<GetOffersResponse> {
    const apiToken = await this.authService.getAuthToken();

    const response = await this.axiosInstance.get<ApiResponse<GetOffersResponse>>('', {
      params,
      headers: {
        ...getUserIdAndFingerPrintHeader('offers', config),
        ...(apiToken && { Authorization: `Bearer ${apiToken}` }),
      },
    });

    return response.data.data;
  }

  async getServiceOffers(
    params: GetServiceOffersQuery,
    config?: { user: Partial<UserInfo> },
  ): Promise<ExtraServiceWithTimeSlice[]> {
    const response = await this.axiosInstance.get<ApiResponse<ExtraServiceWithTimeSlice[]>>('services', {
      params,
      headers: getUserIdAndFingerPrintHeader('offers', config),
    });

    return response.data.data;
  }
}
